import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showSchedulerBuilderModal } from '../../../actions/modalActions';
import { PROJECT, RESOURCE } from '../../scheduler/enums/builderTypeEnum';
import { SCHEDULER_TEMPLATE } from '../../../enums/groupTypeEnum';
import { TYPE_TAB } from '../../scheduler/modals/builder/tabs';
import { useQueryParams } from '../../../utils/useQueryParams';
import PermissionDenied from '../../scheduler/components/permissionDenied/permissionDenied';
import authorization from '../../../services/auth/authorization';
import { useHasRights, useIsExtensionInstalled } from '../../../hooks';
import { SMART_SCHEDULES } from '../../../enums/extensionShortIdEnum';

const rights = [
    {
        rights: ['settingAddNewEditResourceGroups'],
        rule: 'one',
        name: 'canAddNewEditResourceGroup',
    },
];

const NewScheduleRoute = () => {
    const dispatch = useDispatch();
    const queryParams = useQueryParams();
    const { canAddNewEditResourceGroup } = useHasRights(rights);
    const isSmartSchedulesInstalled = useIsExtensionInstalled(SMART_SCHEDULES);

    useEffect(() => {
        const redirectFallback = () => {
            if (queryParams.fallbackUrl) {
                window.location.href = queryParams.fallbackUrl;
            } else {
                window.location.href = '/';
            }
        };

        if (!isSmartSchedulesInstalled) {
            redirectFallback();
        }

        dispatch(
            showSchedulerBuilderModal({
                itemTypeName: canAddNewEditResourceGroup ? RESOURCE.name : PROJECT.name,
                itemId: null,
                groupType: SCHEDULER_TEMPLATE,
                initialTab: TYPE_TAB,
                onClose: () => {
                    redirectFallback();
                },
            })
        );
    }, [canAddNewEditResourceGroup, dispatch, isSmartSchedulesInstalled, queryParams.fallbackUrl]);

    return <></>;
};

const authParameters = {
    allowedRoleRights: ['settingAddNewEditProjectGroups', 'settingAddNewEditResourceGroups'],
    redirectOnLackOfRights: true,
    errorComponent: PermissionDenied,
};

export const NewScheduleRouteAuth = authorization(authParameters)(NewScheduleRoute);
